// ウィジェットの表示のモードと、モードの移り方。モードと移る条件は salescore-agent-docs の arch/frontend/specification.md の「表示の段階」に従う。
// モードを読み書きするのはウィジェットの中の部品だけなので、redux ではなく AgentWidget の useReducer に持つ（!7771 のレビュー）。
// ウィジェットの外がモードを読むか変えるようになったら、そのときに redux に移す

// collapsed は入口だけ、compact は入力欄、expanded は会話のパネル。
// 名前は広さで表す。expanded でも入力するので、input という名前だとパネルでは入力しないように読めるため（!7774 のレビュー）
export type AgentWidgetMode = 'collapsed' | 'compact' | 'expanded'

// open：入口を押した。expand：入力欄で広げた。close：× か Esc。idleTimedOut：入力欄のまま操作がなかった
type AgentWidgetEvent = 'open' | 'expand' | 'close' | 'idleTimedOut'

/**
 * 今のモードと起きたことから、次のモードを返す。移れないときは今のモードのまま返す。
 */
export const nextWidgetMode = (mode: AgentWidgetMode, event: AgentWidgetEvent): AgentWidgetMode => {
  switch (event) {
    // 入口を押したら入力欄を出す。すでに開いていればモードを変えない
    case 'open': {
      return mode === 'collapsed' ? 'compact' : mode
    }
    // 回答を表示できるパネルへ広げる。送信時もこの操作を使い、添付時の接続は #10113 で足す。
    case 'expand': {
      return mode === 'compact' ? 'expanded' : mode
    }
    // 入力欄からもパネルからも入口に戻す（PdM の要件 P-2）
    case 'close': {
      return 'collapsed'
    }
    // 入力欄のまま操作がなければ入口に戻す。いつ戻すか（フォーカスがあるときは戻さない）は呼び出し側が決める。パネルは時間で閉じない
    case 'idleTimedOut': {
      return mode === 'compact' ? 'collapsed' : mode
    }
  }
}
